import {getFormattedDate} from '@/utils/commons';

export const formatLeaderboardLastUpdate = (updatedAt, lastUpdate) => {
  if (updatedAt) {
    return getFormattedDate(updatedAt, false, '-', 'mm-dd-yyyy');
  }

  if (lastUpdate) {
    return String(lastUpdate).replaceAll('/', '-');
  }

  return '-';
};
